module.exports = __webpack_public_path__ + "resources/img/img_watchall_apm2_m_en.6a1f50fea5bc1e1377edf8af2153611b.png";